import { Injectable } from '@angular/core';
import { ServerCall } from '@akiba/models_beta_temp';
import { HTTPRequestService } from '../../../services/httpRequest.service';

@Injectable({
  providedIn: 'any'
})
export class OKTAService {

  constructor(private req: HTTPRequestService) { }

  async loadCompany(sc: ServerCall): Promise<ServerCall> {
    return this.req.buildRequestAsync('okta', 'company', sc);
  }

  async signInWithToken(sc: ServerCall): Promise<ServerCall> {
    return this.req.buildRequestAsync('okta', 'login', sc);
  }


}
